(function ($) {
    $(document).ready(function () {

        var $window = $(window),
            $formWrapper = $('#window-configuration > .wrapper:last-child'),
            $quoteScroller = $('.quote-windows-scroller');

        function applyScrollerMargin() {
            $formWrapper.css('margin-top', $quoteScroller.outerHeight() + parseInt($quoteScroller.css('margin-top')) + parseInt($quoteScroller.css('margin-bottom')));
        }

        $window.on('resize', applyScrollerMargin);
        applyScrollerMargin();
    });
})(jQuery);